import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

export const ButtonBlockColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m} 0;
`;

export const ButtonBlockRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.darkBlue};
  z-index: 900;
`;

export const AppContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 88px ${({ theme }) => theme.spacing.m};
  row-gap: ${({ theme }) => theme.spacing.m};
`;

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    width: 80%;
    margin-top: 70px;
  }

  .Toastify__progress-bar--success {
    background: #58c3bb;
  }

  .Toastify__toast--success .Toastify__toast-icon svg {
    fill: #58c3bb;
  }

  .Toastify__progress-bar--error {
    background: #ef374e;
  }

  .Toastify__toast--error .Toastify__toast-icon svg {
    fill: #ef374e;
  }
`;
